import { apiClient } from "src/careflow/ph-core/api_client/api_client";

const baseURL = 'crs/referral';

export interface ReferralStatusStatistics {
  closed: number;
  open: number;
  rejected: number;
  unspecified: number;
}

export interface ReferralCreationDateStatistics {
  month: number;
  year: number;
  numOfRecords: number;
}
export interface ReferralStatistics {
  status: ReferralStatusStatistics;
  creationDate: ReferralCreationDateStatistics[];
}

export const getReferralStatistics = async (): Promise<ReferralStatistics> => {
  const data = await apiClient.get<ReferralStatistics>(`${baseURL}/statistics/all`);
  return data;
};

export const createProgramsByServiceRequest = async (serviceRequestId: string) => {
  const data= await apiClient.post(`${baseURL}/program`, { serviceRequestId });
  return data;
};
